$('[data-fancybox]').fancybox({
	onInit: function (instance) {
		// Change color on start
		var color = instance.group[instance.currIndex].opts.$orig.data('color');
		color = color ? color : '#fff';
		instance.$refs.bg.css({'background-color': color, 'opacity': 1});
	},
	beforeShow: function (instance, current) {
		// Change color when navigating the gallery
		var color = current.opts.$orig.data('color') || '#fff';

		instance.$refs.bg.css('background-color', color);
	}
});

